import { Alert } from '@mui/material'

import { Payment } from '@/@types/payment'
import { Separator } from '@/components/ui/separator'
import { useBillsStore } from '@/stores/bills'
import { useEffect } from 'react'
import { DataTable } from '../../../components'
import { SectionCards } from './section-cards'
import { TABLE_COLUMNS } from './table-columns'
import { TableToolbar } from './table-toolbar'
import { useData } from './use-data'

export default function Bills() {
  const { startDate, endDate, setPayments, setIsLoading } = useBillsStore()
  const { isLoading, error, payments } = useData({
    endDate: endDate ? new Date(endDate) : undefined,
    startDate: startDate ? new Date(startDate) : undefined,
  })

  useEffect(() => {
    if (!isLoading && payments) setPayments(payments)
    setIsLoading(isLoading)

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [payments, isLoading])

  if (error) return <Alert severity="error">{(error as Error).message}</Alert>

  return (
    <>
      <SectionCards />
      <Separator className="bg-[#37393F] my-10" />

      <DataTable
        data={payments ?? []}
        isLoading={isLoading}
        columns={TABLE_COLUMNS}
        inputProps={{ name: 'user.name' as keyof Payment[][0] }}
        toolbar={(table) => <TableToolbar table={table} />}
      />
    </>
  )
}
